export const sendOtp = async (phone: string, landingSlug?: string, httpReferrer?: string) => {
    const response = await fetch('/api/auth/send-otp', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ phone, landingSlug, httpReferrer }),
    });

    const data = await response.json();
    if (!response.ok) {
        // Include status code and full data in error
        throw {
            success: false,
            status: response.status,
            ...data,
        };
    }
    return data;
};

export const validateOtp = async (
    phone: string,
    otp: string,
    landingSlug?: string,
    httpReferrer?: string,
) => {
    const response = await fetch('/api/auth/validate-otp', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ phone, otp, landingSlug, httpReferrer }),
    });
    const data = await response.json();
    if (!response.ok) {
        // Include status code and full data in error
        throw {
            success: false,
            status: response.status,
            ...data,
        };
    }
    return data;
};
